import { render, staticRenderFns } from "./LiveStreams.vue?vue&type=template&id=d5551c74&scoped=true&lang=pug&"
import script from "./LiveStreams.vue?vue&type=script&lang=ts&"
export * from "./LiveStreams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5551c74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5551c74')) {
      api.createRecord('d5551c74', component.options)
    } else {
      api.reload('d5551c74', component.options)
    }
    module.hot.accept("./LiveStreams.vue?vue&type=template&id=d5551c74&scoped=true&lang=pug&", function () {
      api.rerender('d5551c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/LiveStreams.vue"
export default component.exports